var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentStatusUpdateEditNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8081 3.32159L11.7426 2.38709C12.2587 1.87097 13.0955 1.87097 13.6116 2.38709C14.1277 2.9032 14.1277 3.73999 13.6116 4.2561L12.6771 5.19061M10.8081 3.32159L7.31883 6.81087C6.62198 7.50773 6.27354 7.85613 6.03628 8.28073C5.79901 8.70533 5.5603 9.70793 5.33203 10.6667C6.29076 10.4384 7.29336 10.1997 7.71796 9.9624C8.14256 9.72513 8.49096 9.37673 9.18783 8.67987L12.6771 5.19061M10.8081 3.32159L12.6771 5.19061",
    stroke: "#0020F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 10.8284 14 12.2427 13.1213 13.1213C12.2427 14 10.8284 14 8 14C5.17157 14 3.75736 14 2.87868 13.1213C2 12.2427 2 10.8284 2 8C2 5.17157 2 3.75736 2.87868 2.87868C3.75736 2 5.17157 2 8 2",
    stroke: "#0020F5",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentStatusUpdateEditNotebook);
export default __webpack_public_path__ + "static/media/document-status-update-editNotebook.f03f9847fdb0593ac1e08dbe07746633.svg";
export { ForwardRef as ReactComponent };